import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

const triageSearchSchema = z.object({
  status: z.enum(["open", "resolved"]).catch("open"),
  tier: z.coerce.number().optional().catch(undefined),
  programme: z.string().optional().catch(undefined),
  state: z.enum(["acknowledged", "active", "held"]).optional().catch(undefined),
  page: z.coerce.number().catch(1),
  // UI-only: the alert whose detail sheet is open.
  alert: z.coerce.number().optional().catch(undefined),
})

export const Route = createFileRoute("/_app/oncology/triage/")({
  validateSearch: (search: SearchSchemaInput) =>
    triageSearchSchema.parse(search),
})
